import * as Styles from '@screens/lp-default/components/ecosystem/styles';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import Icon from '@components/icons';
import { Cards } from '@screens/lp-default/components/ecosystem/constants';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
import { snowplowButtonClick } from '@analytics/snowplow/events';

interface EcosystemProps {
  id: string;
}
export default function Ecosystem({ id }: EcosystemProps) {
  const handleCardButtonClick = (name: string, link: string) => {
    snowplowButtonClick('hyperlink', '/planos', name, 'afya_section');
    window.open(link, '_blank');
  };
  return (
    <Styles.EcosystemContainer data-testid="ecosystem" id={id}>
      <Styles.EcosystemBannerWrapper>
        <Styles.EcosystemBanner
          src="/images/default-landing-page/ecosystem/lp-ecosystem-banner.webp"
          width={1320}
          height={360}
        />
        <Styles.EcosystemBannerTitle>Soluções Afya como um ecossistema integrado</Styles.EcosystemBannerTitle>
      </Styles.EcosystemBannerWrapper>
      <Styles.EcosystemContent>
        <Styles.EcosystemContentHeader>
          <Styles.EcosystemContentTitle>Produtos do Ecossistema</Styles.EcosystemContentTitle>
          <Styles.EcosystemContentNavigation>
            <Styles.ArrowButton className="arrow-left">
              <Icon icon="arrow-left" size={16} altText="arrow-left" />
            </Styles.ArrowButton>
            <Styles.ArrowButton className="arrow-right">
              <Icon icon="arrow-right" size={16} altText="arrow-right" />
            </Styles.ArrowButton>
          </Styles.EcosystemContentNavigation>
        </Styles.EcosystemContentHeader>
        <Styles.EcosystemCardsWrapper>
          <Styles.StyledSwiper
            slidesPerView={4.2}
            spaceBetween={4}
            pagination={{
              clickable: true,
            }}
            navigation={{
              nextEl: '.arrow-right',
              prevEl: '.arrow-left',
            }}
            modules={[Pagination, Navigation]}
          >
            {Cards.map((card) => (
              <SwiperSlide key={card.id}>
                <Styles.EcosystemCard>
                  <Styles.EcosystemCardImage>
                    <img
                      src={`/images/default-landing-page/ecosystem/${card.image.src}`}
                      alt={card.name}
                      width={card.image.width}
                      height={card.image.height}
                    />
                  </Styles.EcosystemCardImage>
                  <Styles.EcosystemCardDescription>{card.description}</Styles.EcosystemCardDescription>
                  <Styles.EcosystemCardButton onClick={() => handleCardButtonClick(card.name, card.link)}>
                    Acessar <Icon icon="arrow-square-out" size={16} />
                  </Styles.EcosystemCardButton>
                </Styles.EcosystemCard>
              </SwiperSlide>
            ))}
          </Styles.StyledSwiper>
        </Styles.EcosystemCardsWrapper>
      </Styles.EcosystemContent>
    </Styles.EcosystemContainer>
  );
}
